import { render, staticRenderFns } from "./AddQueryAnswerType.vue?vue&type=template&id=42cfe3e8"
import script from "./AddQueryAnswerType.vue?vue&type=script&lang=js"
export * from "./AddQueryAnswerType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports